module.exports = __webpack_public_path__ + "media/images/camera-pat-6c4b86d6b80a8c725f1f38d229692f8c17a36e08aaad12eeb26ad35d8baae5b0.svg";